import { useFilterConfig } from "../../config/filterConfig";

import FilterGroup from "./FilterGroup";



export default function ProviderFilters() {
  const filterGroups = useFilterConfig();

  return (
    <div className="flex w-full flex-col gap-3">
      {filterGroups.map((group) => (
        <FilterGroup key={group.id} group={group} />
      ))}
    </div>
  );
}
